// import { Component, Input, ElementRef, ViewChild, AfterViewInit, HostListener } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';

// @Component({
//   selector: 'app-scroll-spy-nav',
//   templateUrl: './scroll-spy-nav.component.html',
//   styleUrls: ['./scroll-spy-nav.component.less']
// })
// export class ScrollSpyNavComponent implements AfterViewInit {
//   @Input() sections: { id: string; label: string }[] = [];
//   activeSection: string = '';
//   navbarHeight: number = 0;
//   isSticky: boolean = false;
//   @ViewChild('navbar') navbarElement!: ElementRef;
//   @ViewChild('stickyAnchor') stickyAnchor!: ElementRef;

//   constructor(
//     private router: Router,
//     private route: ActivatedRoute
//   ) { }

//   ngAfterViewInit(): void {
//     this.navbarHeight = this.navbarElement.nativeElement.offsetHeight;
//     this.onScroll();

//     const anchor = this.route.snapshot.fragment;
//     if (anchor) {
//       setTimeout(() => {
//         document.getElementById(anchor)?.scrollIntoView({ behavior: 'smooth' });
//         this.activeSection = anchor;
//       }, 0);
//     }
//   }

//   @HostListener('window:scroll', [])
//   onScroll(): void {
//     const anchorTop = this.stickyAnchor.nativeElement.getBoundingClientRect().top;
//     this.isSticky = anchorTop <= 0;

//     if (this.isSticky) {
//       for (const section of this.sections) {
//         const el = document.getElementById(section.id);
//         if (el) {
//           const rect = el.getBoundingClientRect();
//           if (rect.top <= 100 && rect.bottom >= 100) {
//             this.activeSection = section.id;
//             return;
//           }
//         }
//       }
//     } else {
//       this.activeSection = '';
//     }
//   }

//   // onNavClick(sectionId: string, event: Event) {
//   //   event.preventDefault();
//   //   this.router.navigate([], {
//   //     fragment: sectionId,
//   //     queryParamsHandling: 'preserve'
//   //   });

//   //   setTimeout(() => {
//   //     document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
//   //   }, 0);
//   // }

//   onNavClick(sectionId: string, event: Event): void {
//     event.preventDefault();

//     const target = document.getElementById(sectionId);
//     if (target) {
//       const rect = target.getBoundingClientRect();
//       const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//       const navbarHeight = this.navbarHeight;
//       const offset = 30;

//       const scrollTo = rect.top + scrollTop - navbarHeight - offset;

//       window.scrollTo({
//         top: scrollTo,
//         behavior: 'smooth'
//       });

//       history.replaceState(null, '', `#${sectionId}`);
//     }
//   }
// }


import {
  Component,
  ElementRef,
  ViewChild,
  HostListener,
  AfterViewInit,
  Input
} from '@angular/core';

@Component({
  selector: 'app-scroll-spy-nav',
  templateUrl: './scroll-spy-nav.component.html',
  styleUrls: ['./scroll-spy-nav.component.less']
})
export class ScrollSpyNavComponent implements AfterViewInit {
  @Input() sections: { id: string; label: string }[] = [];
  @ViewChild('navbar') navbarElement!: ElementRef;
  @ViewChild('stickyAnchor') stickyAnchor!: ElementRef;
  @ViewChild('navScroll') navScroll!: ElementRef;

  canScrollLeft = false;
  canScrollRight = false;
  navbarHeight: number = 0;
  isSticky: boolean = false;
  activeSection: string = '';


  ngAfterViewInit(): void {
    this.navbarHeight = this.navbarElement.nativeElement.offsetHeight;
    this.onScroll(); // 初始激活处理
    this.checkScrollArrows();

    // setTimeout(() => {
    //   this.navbarHeight = this.navbar.nativeElement.offsetHeight;
    //   this.checkScrollArrows(); // 初始检测箭头是否需要显示
    // });

    // 监听窗口大小变化时重新检查箭头显示
    window.addEventListener('resize', () => {
      this.checkScrollArrows();
    });
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const anchorTop = this.stickyAnchor.nativeElement.getBoundingClientRect().top;
    this.isSticky = anchorTop <= 0;

    if (this.isSticky) {
      for (const section of this.sections) {
        const el = document.getElementById(section.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= this.navbarHeight + 30 && rect.bottom >= this.navbarHeight + 30) {
            this.activeSection = section.id;
            return;
          }
        }
      }
    } else {
      this.activeSection = '';
    }
  }

  onNavClick(sectionId: string, event: Event): void {
    event.preventDefault();

    const target = document.getElementById(sectionId);
    if (target) {
      const rect = target.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const offset = 15;
      const scrollTo = rect.top + scrollTop - this.navbarHeight - offset;

      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth'
      });

      const currentUrl = window.location.pathname + window.location.search;
      history.replaceState(null, '', `${currentUrl}#${sectionId}`);
    }
  }

  scrollNav(direction: 'left' | 'right') {
    const container = this.navScroll.nativeElement;
    const scrollAmount = 200;
    const scrollTo = direction === 'left'
      ? container.scrollLeft - scrollAmount
      : container.scrollLeft + scrollAmount;
    container.scrollTo({ left: scrollTo, behavior: 'smooth' });
  }

  checkScrollArrows() {
    const container = this.navScroll.nativeElement;
    this.canScrollLeft = container.scrollLeft > 0;
    this.canScrollRight = container.scrollLeft + container.clientWidth < container.scrollWidth;
  }

}
